import { localTime } from '../datetime/localTime';
export function generateBuildInfoDev() {
  const now = localTime.now();
  const ts = now.unix;
  const rev = 'devRev';
  const branchName = 'devBranch';
  const repoName = 'devRepo';
  const tsCommit = now.unix;
  const ver = [now.toStringCompact(), repoName, branchName, rev].join('_');
  return {
    ts,
    tsCommit,
    repoName,
    branchName,
    rev,
    ver,
    env: 'dev'
  };
}